var React = require('react');

function ContentPowdr (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"fulcrum"),React.createElement("g",{"data-name":"Layer 2","key":1},React.createElement("g",{"data-name":"Layer 1"},[React.createElement("polygon",{"points":"34.19 14.93 46.25 2.87 45.25 0 22.74 0 21.74 2.87 33.8 14.93 34.19 14.93","key":0}),React.createElement("polygon",{"points":"67.98 52.25 34.19 18.47 33.8 18.47 0.01 52.25 0 52.26 3.83 60.91 3.84 60.91 15.39 60.91 15.4 60.91 15.76 60.91 16.38 60.91 33.99 43.29 51.61 60.91 52.23 60.91 52.59 60.91 52.6 60.91 64.15 60.91 64.16 60.91 67.99 52.26 67.98 52.25","key":1})]))]);
}

ContentPowdr.defaultProps = {"role":"presentation","viewBox":"0 0 67.99 60.9"};

module.exports = ContentPowdr;

ContentPowdr.default = ContentPowdr;
